
import { Sidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, SidebarNavDivider, SidebarNavItem, SidebarNavDropdown, SidebarNavLabel, SidebarNavLink, SidebarNavTitle, SidebarToggler } from './components/Sidebar'


const LibraryModule = {
  Sidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarNavDivider,
  SidebarNavDropdown,
  SidebarNavItem,
  SidebarNavLabel,
  SidebarNavLink,
  SidebarNavTitle,
  SidebarToggler,

  install(Vue) {
    // Register components with vue
    Vue.component("Sidebar", Sidebar)
    Vue.component("SidebarFooter", SidebarFooter)
    Vue.component("SidebarForm", SidebarForm)
    Vue.component("SidebarHeader", SidebarHeader)
    Vue.component("SidebarMinimizer", SidebarMinimizer)
    Vue.component("SidebarNav", SidebarNav)
    Vue.component("SidebarNavDivider", SidebarNavDivider)
    Vue.component("SidebarNavDropdown", SidebarNavDropdown)
    Vue.component("SidebarNavItem", SidebarNavItem)
    Vue.component("SidebarNavLabel", SidebarNavLabel)
    Vue.component("SidebarNavLink", SidebarNavLink)
    Vue.component("SidebarNavTitle", SidebarNavTitle)
    Vue.component("SidebarToggler", SidebarToggler)
  }
};

// Export library
export default LibraryModule

// Export components
export {
  Sidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarNavDivider,
  SidebarNavItem,
  SidebarNavDropdown,
  SidebarNavLabel,
  SidebarNavLink,
  SidebarNavTitle,
  SidebarToggler,
};

